import { Modals } from '@/constants';
import { EVENT_CONSTANTS } from '@/services';
import {
  playerThunks,
  selectActiveChapterId,
  selectIsEpisodeRedeemRequired,
  selectIsPlayerPlaying,
  uiActions,
  useAppDispatch,
  useAppSelector,
} from '@/store';
import { Chapter, Referrer, UserChapterProgress } from '@/types';

import { EpisodeChapterTile as EpisodeChapterTileComponent } from './EpisodeChapterTile.component';

export const EpisodeChapterTile = ({
  index,
  chapter,
  userChapter,
  referrer,
}: {
  index: number;
  chapter: Chapter;
  userChapter?: UserChapterProgress;
  referrer: Referrer;
}) => {
  const dispatch = useAppDispatch();

  const activeChapterId = useAppSelector(selectActiveChapterId);
  const isPlaying = useAppSelector(selectIsPlayerPlaying);
  const isEpisodeRedeemRequired = useAppSelector(state =>
    selectIsEpisodeRedeemRequired(state, chapter.episodeId),
  );

  const chapterState = userChapter?.state ?? 'ready';
  const isChapterVerifiable = chapter.isVerifiable;

  const remainingDuration = Math.ceil(
    (chapter.duration - (userChapter?.progress?.playedDuration ?? 0)) / 60,
  );
  const progressPercentage =
    ((userChapter?.progress?.playedDuration ?? 0) / chapter.duration) * 100;

  const onShowChapterQuizModal = () => {
    dispatch(
      uiActions.setActiveModal({
        name: Modals.CHAPTER_QUIZ,
        params: {
          episodeId: chapter.episodeId,
          chapterId: chapter.chapterId,
        },
      }),
    );
  };

  const onIconClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (isEpisodeRedeemRequired && isChapterVerifiable && index > 0) {
      dispatch(
        playerThunks.initiateRedemption({
          episodeId: chapter.episodeId,
          location: {
            ...referrer,
            button: EVENT_CONSTANTS.BUTTON.REDEEM,
          },
        }),
      );
    } else {
      dispatch(
        playerThunks.chapterPlayPressed({
          activeChapter: {
            episodeId: chapter.episodeId,
            chapterId: chapter.chapterId,
          },
          location: {
            ...referrer,
            button: EVENT_CONSTANTS.BUTTON.PLAY_CHAPTER,
          },
          referrer,
        }),
      );
    }
  };

  return (
    <EpisodeChapterTileComponent
      index={index}
      onIconClick={onIconClick}
      onTileClick={onShowChapterQuizModal}
      chapterType={chapter.type}
      chapterName={chapter.name}
      chapterState={chapterState}
      chapterRemainingDuration={remainingDuration}
      chapterProgressPercentage={progressPercentage}
      isEpisodeRedeemRequired={isEpisodeRedeemRequired}
      isChapterActive={activeChapterId === chapter.chapterId}
      isPlayerActive={isPlaying}
      isChapterVerifiable={isChapterVerifiable}
    />
  );
};
